// import './ShoppingCartPage.less';
import './ShoppingCartPage.less';

export const prefix = 'bm-p-shopping-cart';

export { default } from './ShoppingCartPage';
